import React from 'react';
import { X, AlertCircle } from 'lucide-react';
export const Problem = () => {
  const problems = [{
    title: 'Alisados con formol',
    issue: 'Daña la fibra capilar, olor tóxico, no apto para embarazadas ni niñas'
  }, {
    title: 'Productos anti-frizz del mercado',
    issue: 'Efecto temporal, se va al primer lavado'
  }, {
    title: 'Alisados brasileños tradicionales',
    issue: 'Contienen químicos agresivos, generan caída y sequedad'
  }, {
    title: 'Planchas diarias',
    issue: 'Daño acumulativo por calor, rompe la cutícula'
  }];
  return <section id="problema" className="py-16 bg-beige-50" data-id="element-430">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-431">
        <div className="text-center mb-12" data-id="element-432">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-900 mb-4" data-id="element-433">
            El problema que{' '}
            <span className="metallic-gold-text italic" data-id="element-434">
              nadie quiere admitir
            </span>
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto" data-id="element-435">
            Hay mañanas en que te miras al espejo y simplemente no tienes
            energía para la batalla. El frizz. La humedad de Nueva York. El
            cabello que se encrespa apenas sales por la puerta.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-beige-200 relative overflow-hidden" data-id="element-436">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold-50 rounded-full blur-3xl -mr-32 -mt-32 opacity-50" data-id="element-437"></div>

          <div className="relative z-10" data-id="element-438">
            <div className="flex items-center space-x-3 mb-8" data-id="element-439">
              <AlertCircle className="text-rosegold w-6 h-6" data-id="element-440" />
              <h3 className="text-2xl font-serif text-neutral-900" data-id="element-441">
                La verdad que los salones convencionales no te cuentan
              </h3>
            </div>

            <p className="text-neutral-600 mb-8 leading-relaxed" data-id="element-442">
              La mayoría de los alisados que existen en el mercado funcionan con
              una lógica simple: aplanar tu cabello a la fuerza. Usan formol,
              químicos agresivos y altas temperaturas para romper la estructura
              de tu cabello y obligarlo a verse liso. El problema es que ese
              proceso también rompe, reseca y debilita tu fibra capilar con cada
              sesión.
            </p>

            <div className="grid sm:grid-cols-2 gap-4" data-id="element-443">
              {problems.map((item, index) => <div key={index} className="bg-beige-50/50 rounded-2xl p-5 border border-beige-100 flex items-start space-x-4" data-id="element-444">
                  <div className="bg-rosegold/10 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-445">
                    <X className="w-4 h-4 text-rosegold" data-id="element-446" />
                  </div>
                  <div data-id="element-447">
                    <h4 className="font-medium text-neutral-900 mb-1" data-id="element-448">
                      {item.title}
                    </h4>
                    <p className="text-sm text-neutral-500" data-id="element-449">{item.issue}</p>
                  </div>
                </div>)}
            </div>

            <div className="mt-8 p-6 bg-rosegold/5 rounded-2xl border border-rosegold/10 text-center" data-id="element-450">
              <p className="text-rosegold font-medium" data-id="element-451">
                El alisado convencional no soluciona el problema de raíz — solo
                lo disfraza mientras acelera el daño. Eso no es transformación.
                Eso es dependencia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};